export default __webpack_public_path__ + "static/assets/48845e5afc905e2ebbd0fe9b16bae360.jpg";